module.exports = "<app-container [header]=\"header\">\n\t<ul class=\"m-portlet__nav\" *ngIf=\"newEntry\" headerTools>\n\t\t<li class=\"m-portlet__nav-item\">\n\t\t\t<a href=\"javascript:void(0)\" [routerLink]=\"newEntry.link\" class=\"m-portlet__nav-link btn btn-info m-btn\">\n\t\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\t\t{{newEntry.text}}\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\t<ng-content body></ng-content>\n</app-container>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/list-container/list-container.component.html
// module id = ../../../../../src/app/shared/list-container/list-container.component.html
// module chunks = main